import { useEffect, useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import ComponentePrivado from '../../../../components/roles/ComponentePrivado'
import { AppConstantes, AppMapas } from '../../../../utils/Constantes'
import { Roles } from '../../../../utils/Roles'
import { Autorizacion, Condicionante } from '../../models'
import { InputBusquedaFiltrado } from './InputBuscar'

type Props = {
  autorizacion: Autorizacion | undefined
  condicionantes: Condicionante[] | undefined
  claveNivel: string
  condicionanteSeleccionada: Condicionante | undefined
  setIsModoEditar: (arg: boolean) => void
  setMostrarModalCondicionante: (arg: boolean) => void
  setCondicionanteSeleccionada: (arg: Condicionante) => void
  setClaveNivel: (arg: string) => void
  setIdSeleccionado: (arg: string) => void
  isSuccessRecuperarAutorizacion: boolean
  setIdCondicionanteSeleccionada: (arg: string) => void
  isSuccessGuardar?: boolean
  isSuccessActualizar?: boolean
}
export const DetalleAutorizacionCardCondicionantes = ({
  autorizacion,
  condicionantes,
  condicionanteSeleccionada,
  setIsModoEditar,
  setMostrarModalCondicionante,
  setCondicionanteSeleccionada,
  setClaveNivel,
  setIdSeleccionado,
  isSuccessRecuperarAutorizacion,
  setIdCondicionanteSeleccionada,
  claveNivel,
  isSuccessGuardar,
  isSuccessActualizar
}: Props) => {
  const [palabraInputBusquedaCondicionante, setPalabraInputBusquedaCondicionante] = useState('')
  const [condicionantesFiltradas, setCondicionantesFiltradas] = useState<Condicionante[]>()

  const colorDivCondicionanteSeleccionada = 'bg-hover-light-secondary'
  const colorDivCondicionanteNoSeleccionada='div-no-seleccionado'

  /**
   * @description Cambia el modal a modo edición y lo abre.
   *
   * @author ana.carrasco  Hábil MX
   * @version 1.0.0, 14/11/2022
   */
  const editarCondicionante = () => {
    setIsModoEditar(true)
    setMostrarModalCondicionante(true)
  }

  /**
   * @description Abre modal para nueva condicionante
   *
   * @author ana.carrasco  Hábil MX
   * @version 1.0.0, 17/11/2022
   */
  const agregarNuevaCondicionante = () => {
    setMostrarModalCondicionante(true)
    // Asegura que el modal de condicionante se abra en el contexto de autorización
    // (no de una condicionante ya seleccionada).
    setClaveNivel(AppConstantes.CLAVE_NIVEL_AUTORIZACION)
  }

  /**
   * @description Abre los detalles de tareas de la condicionante
   *              seleccionada. Modifica estilo de la selección y habilita la
   *              tarjeta de "Tareas Condicionante"
   *
   * @author ana.carrasco  Hábil MX
   * @version 1.0.0, 09/11/2022
   * @param idCondicionante   id de la condicionante seleccionada
   */
  const recuperarTareasCondicionante = (condicionante: Condicionante) => {
    setCondicionanteSeleccionada(condicionante)
    // Nota: en este módulo se manejan 2 representaciones del nivel:
    // - constantes `CLAVE_NIVEL_*` (usadas por otros modales)
    // - literales 'autorizacion'/'condicionante' (usadas por este detalle)
    // Se preserva el doble set para no cambiar comportamiento.
    setClaveNivel(AppConstantes.CLAVE_NIVEL_CONDICIONANTE)
    setClaveNivel('condicionante')
  }

  useEffect(() => {
    if (isSuccessRecuperarAutorizacion) {
      // Inicializa lista filtrada con la lista completa al cargar/actualizar.
      setCondicionantesFiltradas(condicionantes)
    }

    setPalabraInputBusquedaCondicionante('')
  }, [isSuccessRecuperarAutorizacion, isSuccessActualizar, isSuccessGuardar])

  return (
    <div id='collapseContactos' className='col-4 '>
      <div className='card  condicionantes-autorizacion card-height'>
        <div className='card-header align-items-center pe-3 px-3'>
          <div className='d-flex align-items-center flex-grow-1 '>
            <h3 className=' d-flex' data-bs-toggle='tooltip' data-bs-title='Default tooltip'>
              Condicionantes
            </h3>
            <span className='text-muted fw-lighter fs-4 ps-2 '>
              |{' '}
              {
                (condicionantesFiltradas !== undefined
                  ? condicionantesFiltradas
                  : autorizacion?.condicionantes
                )?.length
              }{' '}
              total
            </span>{' '}
          </div>
          {AppConstantes.CLAVE_NIVEL_CONDICIONANTE && claveNivel === 'condicionante' ? (
            <div>
              <OverlayTrigger placement={'top'} overlay={<Tooltip>Editar condicionante</Tooltip>}>
                <button
                  className='btn btn-outline-primary btn-icon btn-circle btn-sm'
                  type='button'
                  onClick={() => {
                    editarCondicionante()
                  }}>
                  <i
                    className='fa-solid 
                      fa-pen-to-square fs-3'></i>
                </button>
              </OverlayTrigger>
              <ComponentePrivado rolMostrarPorPermiso={[Roles.roleCondicionantesCrear]}>
                <OverlayTrigger placement={'top'} overlay={<Tooltip>Agregar</Tooltip>}>
                  <button
                    className='btn btn-outline-primary btn-icon btn-circle btn-sm'
                    type='button'
                    title='Agregar '
                    onClick={() => {
                      agregarNuevaCondicionante()
                    }}>
                    <i className='fa-solid fa-plus fs-1'> </i>
                  </button>
                </OverlayTrigger>
              </ComponentePrivado>
            </div>
          ) : (
            <ComponentePrivado rolMostrarPorPermiso={[Roles.roleCondicionantesCrear]}>
              <OverlayTrigger placement={'top'} overlay={<Tooltip>Agregar</Tooltip>}>
                <button
                  className='btn btn-outline-primary btn-icon btn-circle btn-sm'
                  type='button'
                  title='Agregar '
                  onClick={() => {
                    agregarNuevaCondicionante()
                  }}>
                  <i className='fa-solid fa-plus fs-1'></i>
                </button>
              </OverlayTrigger>
            </ComponentePrivado>
          )}
        </div>

        <InputBusquedaFiltrado
          arregloObjetos={autorizacion?.condicionantes}
          setArregloObjetosFiltrados={setCondicionantesFiltradas}
          tipo={AppConstantes.CVE_INPUT_CONDICIONANTE}
          palabraInputBusqueda={palabraInputBusquedaCondicionante}
          setPalabraInputBusqueda={setPalabraInputBusquedaCondicionante}></InputBusquedaFiltrado>

        {(condicionantesFiltradas !== undefined
          ? condicionantesFiltradas
          : autorizacion?.condicionantes
        )?.length === 0 ? (
          <div style={{ marginTop: '25vh' }}>
            <div className=' d-flex justify-content-center ms-5 '>
              <i className=' bi bi-book font-size-icon'></i>
            </div>
            <div className='d-flex justify-content-center ms-5 mt-2'>
              <i style={{ fontSize: '1.2em' }}>Sin condicionantes</i>
            </div>
          </div>
        ) : (
          <div className='overflow-auto'>
            {(condicionantesFiltradas !== undefined
              ? condicionantesFiltradas
              : autorizacion?.condicionantes
            )?.map((condicionante: Condicionante, i: number) => (
              <div
                key={i}
                className={`${
                  condicionante.idCondicionante === condicionanteSeleccionada?.idCondicionante
                    ? colorDivCondicionanteNoSeleccionada
                    : colorDivCondicionanteSeleccionada
                } pt-4 pb-4`}>
                <div
                  className={`d-flex flex-column px-3 mx-1 ${
                    condicionante.idCondicionante === condicionanteSeleccionada?.idCondicionante
                      ? colorDivCondicionanteNoSeleccionada
                      : colorDivCondicionanteSeleccionada
                  }`}
                  key={condicionante.idCondicionante}
                  onClick={() => {
                    // Selección de condicionante:
                    // - habilita tarjeta de tareas en modo condicionante
                    // - actualiza IDs seleccionados para query de tareas
                    recuperarTareasCondicionante(condicionante)
                    setIdSeleccionado(`${condicionante.idCondicionante}`)
                    setIdCondicionanteSeleccionada(`condicionante/${condicionante.idCondicionante}`)
                  }}>
                  <div className='d-flex justify-content-between '>
                    <h4
                      className='d-flex flex-column px-0 ps-0 mt-3  text-hover div-titulo-cards'
                      key={condicionante.idCondicionante}>
                      {condicionante.nombre}
                    </h4>
                    <div className='ms-2'>
                      <span
                        className={`fs-7 mx-0 align-items-center  fw-bold px-3 py-2 mt-2 ms-2 text-wh badge  badge-light-${
                          AppMapas.MAPA_ESTATUS_CONDICIONANTE.get(condicionante.estatus) ??
                          'text-info'
                        }`}>
                        {' '}
                        {AppMapas.MAPA_ESTATUS_CONDICIONANTES_DESCRIPCIONES.get(
                          condicionante.estatus
                        )}
                      </span>
                    </div>
                  </div>
                  <div
                    className={`d-flex flex-column flex-fill me-0 my-2 fs-6 ${
                      condicionante.idCondicionante === condicionanteSeleccionada?.idCondicionante
                        ? colorDivCondicionanteNoSeleccionada
                        : colorDivCondicionanteSeleccionada
                    }`}>
                    <p className='text-gray-700 fs-5'>{condicionante.descripcion}</p>
                  </div>

                  <div
                    className={`flex-fill me-0  mt-1  d-flex justify-content-between ${
                      condicionante.idCondicionante === condicionanteSeleccionada?.idCondicionante
                        ? colorDivCondicionanteNoSeleccionada
                        : colorDivCondicionanteSeleccionada
                    }`}>
                    <p className=' fw-semibold text-gray-600  fs-5'>Periodicidad</p>
                    <p className='fw-bold  text-gray-700 fs-5'>
                      {AppMapas.MAPA_PERIODICIDAD_CONDICIONANTES_DESCRIPCIONES.get(
                        condicionante.periodicidad
                      )}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
